/* unplugin-vue-components disabled */import script from "./MarketPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketPage.vue?vue&type=script&setup=true&lang=js"

import "./MarketPage.vue?vue&type=style&index=0&id=587a2786&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-587a2786"]])

export default __exports__